import { useFormContext } from 'react-hook-form';

import { type BlockedRecordExamCenterManagerFormInput } from './schema';

export const useBlockedRecordExamCenterManagerFormContext =
  useFormContext<BlockedRecordExamCenterManagerFormInput>;
